import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export const useRedirectToProposal = ()=>{
    const history = useHistory();
    const overlayContext = useOverlayContext();
    const { updateUserClientData, logBI } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const redirectToProposal = async (param)=>{
        let { proposalType, draftId, state } = param;
        try {
            overlayContext.startLoader('temp');
            await updateUserClientData({
                lastSelectedProposal: proposalType
            });
            overlayContext.stopLoader('temp');
            const studioPath = draftId ? routes.draft(draftId) : routes.agreementStudio;
            switch(proposalType){
                case 'agreement':
                    logBI(10350, {});
                    history.push(studioPath, state);
                    break;
                case 'invite':
                    logBI(10353, {});
                    history.push("".concat(studioPath, "/existing-client"), state);
                    break;
            }
        } catch (e) {
            overlayContext.stopLoader('temp');
            overlayContext.showErrorToast(commonTexts.toasts.failedToCreateProposal(), 'create-proposal-error-toast');
        }
    };
    const openCreationModal = async function openCreationModal() {
        let { draftIdGetter, state } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (typeof draftIdGetter !== 'undefined') {
            const draftId = await draftIdGetter('agreement');
            await redirectToProposal({
                proposalType: 'agreement',
                draftId,
                state
            });
        } else {
            await redirectToProposal({
                proposalType: 'agreement',
                state
            });
        }
    };
    return {
        openCreationModal,
        redirectToProposal
    };
};
